
import React from "react";
import { useGlobalContext } from "../../context";
import { inputType } from "../../interfaces";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

function Websites() {

    const { webSitesData, setWebSitesData } = useGlobalContext();

    const handleWebsiteChange = (value: string, id: number): void => {
        setWebSitesData((websites: inputType[]) => websites.map((item: inputType) => item.id === id ? { ...item, text: value } : { ...item }));
    }

    const addWebsite = (): void => {
        if (webSitesData.length < 5) {
            const lastId: number = webSitesData[webSitesData.length - 1].id + 1;
            setWebSitesData((webSitesData: inputType[]) => {
                return [
                    ...webSitesData,
                    {
                        id: lastId,
                        text: ""
                    }
                ]
            })
        }
    }

    const deleteWebsite = (id: number): void => {
        setWebSitesData((webData: inputType[]) => webData.filter((e: inputType) => e.id !== id));
    }

    return(
        <div className="Websites">
            <div className="form-emailAddress-box">
                <label className="required">Website <span>Max 5</span></label>
            </div>
            <div>
                {
                    webSitesData.map((ws: inputType) => (
                        <div className="form-emailAddress-box " key = { ws.id }>
                            <input
                                className = "emailAddress-box-email-input"
                                type = "email"
                                value = { ws.text }
                                onChange = {(e) => handleWebsiteChange(e.target.value, ws.id)}
                            />
                            {
                                ws.id === 1 ?
                                    <div className = "emailAddress-box-add">
                                        <AddIcon
                                            className = "box-addEmail-icon"
                                            onClick = { addWebsite }
                                        />
                                    </div>
                                    :
                                    <div className="phoneNumber-box-delete">
                                        <DeleteIcon
                                            className = "box-deletePhone-icon"
                                            onClick = {() => deleteWebsite(ws.id)}
                                        />
                                    </div>
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Websites
